import { useContext, useEffect, useState } from "react";
import { getData } from "src/actions/getData";
import { RxExternalLink } from "react-icons/rx";
import { CgPlayListAdd } from "react-icons/cg";
import { VscSync } from "react-icons/vsc";
import { TbReload } from "react-icons/tb";
import { PiWarehouse } from "react-icons/pi";
import PageHeader from "src/components/PageHeader";
import Table from "src/components/Table";
import Modal from "src/components/Modal";
import ModalBody from "src/components/Modal/ModalBody";
import ModalHeader from "src/components/Modal/ModalHeader";
import ModalFooter from "src/components/Modal/ModalFooter";
import TwinButton from "src/components/TwinButton";
import { get, post } from "src/services/HttpClient";
import { notify } from "src/services/Notification/Notification";
import shopContext from "src/context/shopContext";
import MiniInfoButton from "src/components/MiniInfoButton";
import Barcode from "react-barcode";

export default function SepidarSync() {
    const [rowData, setRowData] = useState()
    const [isInsertModalOpen, setIsInsertModalOpen] = useState(false)
    const [isEditModalOpen, setIsEditModalOpen] = useState(false)
    const [isSyncStockModalOpen, setIsSyncStockModalOpen] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const { inconsistenceItems, setInconsistenceItems } = useContext(shopContext)

    useEffect(() => {
        if (!inconsistenceItems) {
            getData(setInconsistenceItems, "/sepidar/inconsistenceItems");
        }
    }, [])


    const columns = [
        {
            id: "image",
            cell: (info) => (<img className="w-[80px] max-w-[80px] rounded-lg" src={info.getValue()} />),
            header: "تصویر",
            inExport: false,
        },
        {
            id: "id",
            cell: (info) => info.getValue(),
            header: "شناسه سایت",
        },
        {
            id: "itemID",
            cell: (info) => info.getValue(),
            header: "شناسه سپیدار",
        },
        {
            id: "siteName",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "نام سایت",
        },
        {
            id: "sepidarName",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "نام سپیدار",
        },
        {
            id: "titlesCompatible",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "تطابق عنوان‌ها",
        },
        {
            id: "sku",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "sku سایت",
        },
        {
            id: "code",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "sku سپیدار",
        },
        {
            id: "global_unique_id",
            cell: (info) => info.getValue() ? <Barcode value={info.getValue()} height={40} width={1.5} /> : "---",
            header: "بارکد سایت",
        },
        {
            id: "barCode",
            cell: (info) => info.getValue() ? <Barcode value={info.getValue()} height={40} width={1.5} /> : "---",
            header: "بارکد سپیدار",
        },
        {
            id: "barcodesCompatible",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "تطابق بارکدها",
        },
        {
            id: "stock_quantity",
            cell: (info) => info.getValue() ? info.getValue() : info.getValue() == 0 ? "0" : "---",
            header: "موجودی سایت",
        },
        {
            id: "reservedQuantity",
            cell: (info) => info.getValue() ? info.getValue() : info.getValue() == 0 ? "0" : "---",
            header: "موجودی رزرو",
        },
        {
            id: "missedQuantity",
            cell: (info) => info.getValue() ? info.getValue() : info.getValue() == 0 ? "0" : "---",
            header: "موجودی فاکتور نشده",
        },
        {
            id: "sepQuantity",
            cell: (info) => info.getValue() ? info.getValue() : info.getValue() == 0 ? "0" : "---",
            header: "موجودی انبار",
        },
        {
            id: "stockSummaryFa",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "موجود در",
        },
        {
            id: "stocksCompatible",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "تطابق موجودی‌ها",
        },
        {
            id: "taxRate",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "نرخ مالیات",
            inTable: false,
            inExport: true
        },
        {
            id: "alStatus",
            cell: (info) => info.getValue() ? <MiniInfoButton text={info.getValue()} color={info.row.original.color} /> : "---",
            header: "وضعیت",
        },
        {
            id: "id",
            cell: (info) => (
                <div className="flex gap-2">
                    {
                        info.row.original.permalink
                        &&
                        <a
                            title="لینک محصول"
                            className="cursor-pointer hover:bg-gray-100 hover:text-gray-600 transition-all ease-in-out duration-300 dark:bg-gray-700 bg-gray-50 text-gray-400 p-2 rounded-lg"
                            target="_blank"
                            href={info.row.original.permalink}
                        >
                            <RxExternalLink className="text-blue-500" />
                        </a>
                    }
                    {
                        info.row.original.sepidarName && info.row.original.siteName
                        &&
                        <div
                            title="همگام سازی موجودی انبار"
                            className="cursor-pointer hover:bg-gray-100 hover:text-gray-600 transition-all ease-in-out duration-300 dark:bg-gray-700 bg-gray-50 text-gray-400 p-2 rounded-lg"
                            onClick={() => {
                                setRowData(info.row.original)
                                setIsSyncStockModalOpen(true)
                            }}
                        >
                            <PiWarehouse className="text-red-500" />
                        </div>
                    }
                    {
                        !info.row.original.sepidarName
                        &&
                        <div
                            title="درج دستی محصول در سپیدار"
                            className="cursor-pointer hover:bg-gray-100 hover:text-gray-600 transition-all ease-in-out duration-300 dark:bg-gray-700 bg-gray-50 text-gray-400 p-2 rounded-lg"
                            onClick={() => {
                                setRowData(info.row.original)
                                setIsInsertModalOpen(true)
                            }}
                        >
                            <CgPlayListAdd className="text-orange-500" />
                        </div>
                    }
                    {
                        info.row.original.sepidarName && info.row.original.siteName
                        &&
                        <div
                            title="همگام سازی محصولِ سپیدار با سایت"
                            className="cursor-pointer hover:bg-gray-100 hover:text-gray-600 transition-all ease-in-out duration-300 dark:bg-gray-700 bg-gray-50 text-gray-400 p-2 rounded-lg"
                            onClick={() => {
                                setRowData(info.row.original)
                                setIsEditModalOpen(true)
                            }}
                        >
                            <VscSync className="text-purple-500" />
                        </div>
                    }
                </div>
            ),
            header: "عملیات",
            inExport: false,
            footer: (info) => info.column.id,
            enableColumnFilter: false,
        },

    ];

    return (
        <>
            <PageHeader
                title="وضعیت محصولات سایت و سپیدار"
                btnTitle="بروزرسانی"
                handleClick={() => {
                    setInconsistenceItems();
                    getData(setInconsistenceItems, "/sepidar/inconsistenceItems");
                }}
                btnIcon={<TbReload className="ml-1" size="20" />}
                isBtnLoading={!inconsistenceItems}
            />
            <Table data={inconsistenceItems} columns={columns} CSVExportPermission="exportInventory" />

            <Modal isOpen={isSyncStockModalOpen} toggle={setIsSyncStockModalOpen}>
                <ModalHeader>
                    همگام سازی موجودی سایت و سپیدار
                </ModalHeader>
                <ModalBody>
                    <div className="p-5">
                        آیا از انجام این عملیات مطمئن هستید؟
                    </div>
                </ModalBody>
                <ModalFooter>
                    <TwinButton
                        isCompact={true}
                        rejectTitle="انصراف"
                        acceptTitle="همگام‌سازی موجودی"
                        acceptHandle={async () => {
                            setIsLoading(true)
                            let result = await get(`/sepidar/syncStocks/${rowData.sku}`)
                            let errorType = result?.success ? "success" : "error"
                            notify(result?.message?.title || result?.message?.message, errorType)
                            setIsLoading(false)
                            setIsSyncStockModalOpen(false)
                        }}
                        rejectHandle={() => { setIsSyncStockModalOpen(false) }}
                        isLoading={isLoading}
                    />
                </ModalFooter>
            </Modal>

            <Modal isOpen={isInsertModalOpen} toggle={setIsInsertModalOpen}>
                <ModalHeader>
                    درج دستی محصول در سپیدار
                </ModalHeader>
                <ModalBody>
                    <div className="p-5">
                        آیا از انجام این عملیات مطمئن هستید؟
                    </div>
                </ModalBody>
                <ModalFooter>
                    <TwinButton
                        isCompact={true}
                        rejectTitle="انصراف"
                        acceptTitle="درج در سپیدار"
                        acceptHandle={async () => {
                            let result = await post("/sepidar/inventory/postItem", [
                                {
                                    "type": 1,
                                    "code": rowData.sku,
                                    "title": rowData.siteName,
                                    "title_En": rowData.siteName,
                                    "unitRef": 1,
                                    "taxExempt": false,
                                    "taxExemptPurchase": false,
                                    "sellable": true,
                                    "isActive": true,
                                    "taxRate": 10,
                                    "dutyRate": 0,
                                    "barCode": rowData.global_unique_id ? rowData.global_unique_id : null,
                                }
                            ]
                            )
                            let errorType = result?.success ? "success" : "error"
                            notify(result?.message?.title || result?.message?.message, errorType)
                            setIsInsertModalOpen(false)
                        }}
                        rejectHandle={() => { setIsInsertModalOpen(false) }}
                    />
                </ModalFooter>
            </Modal>
            <Modal isOpen={isEditModalOpen} toggle={setIsEditModalOpen}>
                <ModalHeader>
                    همگام سازی محصولِ سپیدار با سایت
                </ModalHeader>
                <ModalBody>
                    <div className="p-5">
                        آیا از انجام این عملیات مطمئن هستید؟
                    </div>
                </ModalBody>
                <ModalFooter>
                    <TwinButton
                        isCompact={true}
                        rejectTitle="انصراف"
                        acceptTitle="همگام‌سازی سپیدار"
                        acceptHandle={async () => {
                            let result = await post("/sepidar/inventory/putItem", [
                                {
                                    "itemID": rowData.itemID,
                                    "title": rowData.siteName,
                                    "title_En": rowData.siteName,
                                    "barCode": rowData.global_unique_id ? rowData.global_unique_id : null,
                                }
                            ]
                            )
                            let errorType = result?.success ? "success" : "error"
                            notify(result?.message?.title || result?.message?.message, errorType)
                            setIsEditModalOpen(false)
                        }}
                        rejectHandle={() => { setIsEditModalOpen(false) }}
                    />
                </ModalFooter>
            </Modal>
        </>
    )
}
